import {
  PASSWORD_FAILURE,
  PASSWORD_LOADING,
  PASSWORD_REJECTED,
  PASSWORD_SUCCESS,
  PASSWORD_UPDATE,
  USERS_FAILURE,
  USERS_LOADING,
  USERS_SUCCESS,
  USERS_UPDATE_FAILURE,
  USERS_UPDATE_SUCCESS,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  loading: false,
  is_password_loading: true,
  firstName: '',
  lastName: '',
  email: '',
  firstLogin: null,
  errorMessage: '',
  updateMessage: null,
  passwordResponse: null,
  usersPasswordRejected: false,
  passwordSuccess: false,
};

// reducer

export const reducer = createReducer(defaultState, {
  [PASSWORD_LOADING]: handlePassLoading,
  [USERS_LOADING]: handleUsersLoading,
  [USERS_SUCCESS]: handleUsersSuccess,
  [USERS_FAILURE]: handleUsersFailure,
  [USERS_UPDATE_SUCCESS]: handleUsersUpdateSuccess,
  [USERS_UPDATE_FAILURE]: handleUsersUpdateFailure,
  [PASSWORD_REJECTED]: handlePasswordRejected,
  [PASSWORD_SUCCESS]: handlePasswordSuccess,
  [PASSWORD_FAILURE]: handlePasswordFailure,
  [PASSWORD_UPDATE]: handlePasswordUpdate,
});

// user
function handleUsersLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handlePassLoading(state, action) {
  return {
    ...state,
    is_password_loading: true,
  };
}

function handleUsersSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    is_password_loading: false,
    firstName: response['first_name'],
    lastName: response['last_name'],
    email: response['username'],
    firstLogin: response['first_login'],
    updateMessage: null,
  };
}

function handleUsersFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    is_password_loading: false,
    errorMessage: error,
  };
}

function handleUsersUpdateSuccess(
  state,
  { payload: { response, first_name, last_name } },
) {
  return {
    ...state,
    firstName: first_name,
    lastName: last_name,
    updateMessage: response['message'],
  };
}

function handleUsersUpdateFailure(state, { payload: { error } }) {
  return {
    ...state,
    firstName: '',
    lastName: '',
    updateMessage: null,
  };
}

// password
function handlePasswordSuccess(state, { payload: { response } }) {
  return {
    ...state,
    is_password_loading: false,
    passwordSuccess: true,
    passwordRejected: false,
    passwordResponse: response?.message,
  };
}

function handlePasswordRejected(state, { payload: { response } }) {
  return {
    ...state,
    is_password_loading: false,
    passwordSuccess: false,
    passwordRejected: true,
    usersPasswordRejected: response?.message,
  };
}

function handlePasswordFailure(state, { payload: { response } }) {
  return {
    ...state,
    is_password_loading: false,
    passwordSuccess: false,
    passwordRejected: false,
    passwordResponse: response?.message,
  };
}

function handlePasswordUpdate(state, { payload: { response } }) {
  return {
    ...state,
    is_password_loading: false,
    updatePassMessage: response,
  };
}

// actions

export function getUserInformation(headers) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USERS_LOADING });

    try {
      const response = await dataSource.requestUserInformation(headers);
      dispatch({ type: USERS_SUCCESS, payload: { response } });
    } catch (error) {
      dispatch({
        type: USERS_FAILURE,
        payload: { error },
      });
    }
  };
}

export function updateUserInformation(first_name, last_name) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    try {
      let response = await dataSource.requestUpdateUser({
        first_name: first_name,
        last_name: last_name,
      });

      dispatch({
        type: USERS_UPDATE_SUCCESS,
        payload: { response, first_name, last_name },
      });
    } catch (error) {
      console.log('updateUserInformation error', error);
      dispatch({
        type: USERS_UPDATE_FAILURE,
        payload: { error },
      });
    }
  };
}

export function updateUserPassword(new_password, confirm_password) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: PASSWORD_LOADING });
    try {
      const response = await dataSource.requestUpdatePassword({
        new_password: new_password,
        confirm_password: confirm_password,
      });
      if (!response?.hasOwnProperty('status')) {
        dispatch({ type: PASSWORD_SUCCESS, payload: { response } });
      } else if (response?.status === 406) {
        dispatch({ type: PASSWORD_REJECTED, payload: { response } });
      } else {
        dispatch({ type: PASSWORD_FAILURE, payload: { response } });
      }
    } catch (error) {
      console.log('requestUpdatePassword error', error);
      dispatch({ type: PASSWORD_FAILURE, payload: { error } });
    }
  };
}
